import { useSharedAssujettiAnswers } from "@src/components/questionnaire/SharedAssujettiAnswersProvider";
import { useQuestionnaireDefinitionsQuery } from "@src/data/questionnaire/hook/useQuestionnaireDefinitionsQuery";
import { useQuestionnaireInstancesQuery } from "@src/data/questionnaire/hook/useQuestionnaireInstancesQuery";
import { getSharedAssujettiAnswerKey } from "@src/helper/sharedAssujettiQuestions.helper";
import { useEffect } from "react";

export function useSeedSharedAssujettiAnswers(assujettiId: string | undefined) {
  const context = useSharedAssujettiAnswers();
  const publishSharedAnswer = context?.publishSharedAnswer;

  const { data: instances } = useQuestionnaireInstancesQuery(
    "ASSUJETTI",
    assujettiId
  );
  const { data: definitions } = useQuestionnaireDefinitionsQuery();

  useEffect(() => {
    if (!publishSharedAnswer || !instances || !definitions) return;

    const definitionById = new Map(definitions.map((d) => [d.id, d]));

    instances.forEach((instance) => {
      const definition = definitionById.get(instance.questionnaireDefinitionId);
      if (!definition) return;

      const orderByQuestionId = new Map(
        definition.questions.map((q) => [q.id, q.order])
      );

      instance.answers.forEach((answer) => {
        const order = orderByQuestionId.get(answer.questionDefinitionId);
        if (order === undefined) return;
        const key = getSharedAssujettiAnswerKey(definition.slug, order);
        if (!key) return;
        const label = answer.options.find((o) => o.id === answer.value)?.label;
        if (label) publishSharedAnswer(key, label);
      });
    });
  }, [publishSharedAnswer, instances, definitions]);
}
